import {PropertyItem} from 'common/widgets/query-block/properties-menu/types';
import {PropertyType, ResourceType} from 'common/widgets/property-filter-menu/models/types';

export const TOP_PEOPLE: PropertyItem = {
  type: null,
  propertyDefaultType: null,
  hasCaret: false,
  hasPill: false,
  icon: `profile`,
  isDisabled: false,
  label: `All User Profiles`,
  value: `$all_people`,
  resourceType: ResourceType.User,
};

export const TOP_PATHS: PropertyItem = {
  type: PropertyType.NonProperty,
  propertyDefaultType: PropertyType.NonProperty,
  hasCaret: false,
  hasPill: false,
  icon: `top-paths`,
  isDisabled: false,
  label: `Top paths`,
  value: `$paths`,
  resourceType: ResourceType.Other,
};

export const ALL_USERS_COHORT: PropertyItem = {
  type: null,
  propertyDefaultType: null,
  hasCaret: false,
  hasPill: false,
  isDisabled: false,
  label: `All Users`,
  value: `$all_users`,
  resourceType: ResourceType.Cohort,
};

export const OTHER_OPTIONS: Map<string, PropertyItem> = new Map([[`$paths`, TOP_PATHS]]);
